import React from 'react';
import PropTypes from 'prop-types';
import BusinessStorage from '/assets/images/psp/psplinkscard/BusinessStorage.svg';

import { H2, Image } from 'components/atoms';
import { PSPLinksCardGrid } from 'components/molecules';
import { Container } from 'components/atoms/Page';

import './PSPLinks.scss';

export default function PSPLinks({ title, cards, pageType }) {
	return (
		<section className="psp-links-section">
			<Container>
				<div className="psp-links-main">
					<div className="psp-links-hero">
						<Image
							className="psp-bs-image"
							src={BusinessStorage}
							alt="Business Storage Icon"
							height="60"
							width="60"
						/>
						<H2 className="psp-text">{title}</H2>
					</div>
				</div>
				<PSPLinksCardGrid links={cards} pageType={pageType}/>
			</Container>
		</section>
	);
}

PSPLinks.propTypes = {
	title: PropTypes.string.isRequired,
	cards: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			image: PropTypes.string.isRequired,
			link: PropTypes.string.isRequired,
		})
	).isRequired,
	pageType: PropTypes.string,
};

PSPLinks.defaultProps = {
	title: '',
	cards: [],
	pageType: ""

};
